<div class="flex flex-col items-center gap-6 pb-4 px-4" [class]="direction"
    [ngClass]="isDesktop ? 'w-[30.25rem]' : 'w-full'">
    <!--
      a11y: top close (X) button, FIRST in DOM and [focusInitial]=true so the
      CDK focus trap places initial focus here on open. Without it, focus
      previously landed on one of the Yes/No buttons, neither of which is a
      neutral default. Activating returns `undefined` from closeCard, which
      the caller treats as "user dismissed without answering".
    -->
    <div class="w-full !flex justify-end">
      <mot-button matType="icon" icon="close"
        [ariaLabel]="closeText"
        class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
        [focusInitial]="true"
        (onClick)="closeCard()" />
    </div>

    <div class="flex flex-col gap-2 items-center w-full">
        <!-- a11y: popup heading is h2 (page-level h1 is the nav-bar logo). -->
        <h2 class="m-0 font-semibold text-xl text-center">{{ questionText }}</h2>
    </div>
    <div class="flex w-full gap-4 justify-center" [ngClass]="{'flex-col' : isMobile}">
        <mot-button 
            [text]="noText" 
            buttonClass="!border !border-solid !border-primary !bg-white !text-primary !w-full !rounded-lg !align-middle !py-3"
            (onClick)="handleClick(false)" 
            [ngClass]="isDesktop ? '!w-[13.625rem]' : 'w-full'" />
        <mot-button 
            [text]="yesText" 
            buttonClass="!bg-primary !text-white !w-full !rounded-lg !align-middle !py-3"
            (onClick)="handleClick(true)" 
            [ngClass]="isDesktop ? '!w-[13.625rem]' : 'w-full'" />
    </div>
</div>

